/* eslint-disable import/no-cycle */
/* eslint-disable import/first */
import React, { useEffect, useState, useRef } from 'react';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';

/* eslint-disable import/first */
import { Redux, Slices } from 'spwa-ui-library';
const { useSelector } = Redux;
import { navigate, useLocation } from '@reach/router';
import { useIntl } from 'react-intl';
import ClassNames from 'classnames';
import { FaCheck } from '@react-icons/all-files/fa/FaCheck';
import get from 'lodash/get';
import Popover from '@material-ui/core/Popover';
const { selectDesktop } = Slices.appSlice;
const { selectBaseURL, selectOrderModesByCountry } = Slices.configSlice;
const { selectCurrentCountry } = Slices.profileSlice;
import OrderModeButton from './OrderModeButton';
// import DialogBox from '../DialogBox';
// eslint:fix DialogBox is defined but never used
import SavedAddress from '../SavedAddress';
import AddAddress from '../../containers/AddAddress';
import Pickup from '../../containers/Pickup';
import EditAddress from '../../containers/EditAddress';
import Carhop from '../../containers/Carhop';
import DineIn from '../../containers/DineIn';
import DriveThru from '../../containers/DriveThru';

import css from './index.module.scss';
import { tabChangeGA } from 'spwa-ui-library/esm/utils/helperGA';
import { getOrderModeLink } from 'spwa-ui-library/esm/utils/helper';
export default function OrderModesBar({
  action = '',
  defaultModeIdx = null,
  isDesktopHeader = false,
}) {
  const intl = useIntl();
  const refRoot = useRef(null);
  // const dispatch = useDispatch();
  // eslint:fix dispatch is defined but never used
  const location = useLocation();
  const isDesktop = useSelector(selectDesktop);
  const country = useSelector(selectCurrentCountry);

  const orderModes = useSelector((state) => selectOrderModesByCountry(state, country));
  const imgBaseUrl = useSelector(selectBaseURL);
  // const address = useSelector(selectDefaultAddress);
  // eslint:fix address is assigned a value but never used
  const mainAddress = useSelector((state) => state.address);
  const auth = useSelector((state) => state.auth);
  const [defaultIdx, setDefaultIdx] = useState(defaultModeIdx);
  const [selectedIdx, setSelectedIdx] = useState(defaultModeIdx);
  const [tab, setTab] = useState(null);
  const [orderModeChange, setOrderModeChange] = useState(false);
  const [addressId, setAddressId] = useState('');
  const [isOrderModeDialogOpen, setOrderModeDialogOpen] = useState(false);
  const [pathOfMode, setPathOfMode] = useState('');
  const [positionPop, setPositionPop] = useState(null);
  const selectedOrderMode = get(orderModes, `[${selectedIdx}].type`, '').toLowerCase();

  const lang = intl.locale.split('-')[0].toLowerCase();

  const handleDialogClose = (event) => {
    setSelectedIdx(null);
    setOrderModeChange(false);
    navigate(-1);
  };
  const modeRoute = {
    delivery: {
      path: 'delivery',
      component: <SavedAddress closePopUp={handleDialogClose} showAction={true} />,
    },
    addaddress: {
      path: 'addAddress',
      component: <AddAddress closePopUp={handleDialogClose} />,
    },
    editaddress: {
      path: 'editaddress',
      component: <EditAddress addressId={addressId} closePopUp={handleDialogClose} />,
    },
    store: { path: 'pickup', component: <Pickup closePopUp={handleDialogClose} /> },
    carhop: { path: 'carhop', component: <Carhop closePopUp={handleDialogClose} /> },
    dinein: { path: 'dinein', component: <DineIn closePopUp={handleDialogClose} /> },
    drivethru: { path: 'drivethru', component: <DriveThru closePopUp={handleDialogClose} /> },
  };
  const addLength =
    (mainAddress.default?.info?.data && Object.entries(mainAddress.default?.info?.data).length) ||
    0;
  const isUserAccessFirstTime =
    window.localStorage.getItem('addressType')?.toLowerCase() === 'delivery' && auth.isLoggedIn;

  useEffect(() => {
    if (defaultModeIdx === null) {
      if (orderModes && orderModes.length && addLength && !defaultIdx) {
        for (let i = 0; i < orderModes.length; i++) {
          const element = orderModes[i];

          if (element.type === mainAddress?.default?.info?.data?.addressSubType) {
            !isDesktop && setSelectedIdx((prev) => null);
            setTab((prev) => i);
            if (addLength && !orderModeChange) {
              setSelectedIdx((prev) => i);
            }
          }
        }
      } else {
        const idx = orderModes.findIndex((el) => el.default === true);
        setDefaultIdx(selectedIdx || idx);
        setTab(selectedIdx || idx);
        setSelectedIdx((prev) => selectedIdx || idx);
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mainAddress, mainAddress.default?.info?.data, addLength]);

  useEffect(() => {
    const search = new URLSearchParams(location.search);
    const indexDelivery = orderModes.findIndex((el) => el.type === 'DELIVERY');
    const modalName = (search.get('modal') || '').toLowerCase();
    const addressId = search.get('addId') || '';
    const modeObject = Object.keys(modeRoute).find((mode) => mode === modalName);
    if (addressId) {
      setAddressId(addressId);
    }
    const orderMode = orderModes.filter((mode) => mode.type === modalName.toUpperCase());

    const enableOrderModeChange =
      modalName == 'addaddress' || modalName == 'editaddress'
        ? true
        : orderMode.length > 0 && orderMode[0].enable;

    if (modalName && modeObject && enableOrderModeChange) {
      setOrderModeDialogOpen(true);
      setPathOfMode(modalName);

      const index = orderModes.findIndex((el) => el.type === modalName.toUpperCase());
      setSelectedIdx((prev) => index);
    } else if (isOrderModeDialogOpen) {
      setOrderModeDialogOpen(false);
      setSelectedIdx((prev) => null);
      setPathOfMode('');
    }
    if (modalName === 'addaddress') {
      setSelectedIdx((prev) => indexDelivery);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.search]);

  useEffect(() => {
    if (refRoot.current) {
      const parentEl = refRoot.current;
      setPositionPop({
        horizontal:
          intl.locale === 'en'
            ? parentEl.offsetLeft
            : parentEl.offsetLeft + parentEl.offsetWidth - 640,
        vertical: 1,
      });
    }
  }, [intl.locale]);

  const handleOrderModeChange = (event, newValue) => {
    event.preventDefault();
    tabChangeGA(newValue, selectedIdx);
    setDefaultIdx(null);
    setSelectedIdx((prev) => newValue);
    setOrderModeChange(true);
    const modalName = orderModes[newValue].type.toLowerCase();

    const orderModeURL = getURL({
      path: location.pathname,
      queryParams: location.search,
      modeType: modalName,
      isDesktop: isDesktop,
      locale: intl.locale,
    });

    if (isDesktop) {
      const qs = new URLSearchParams(location.search);
      if (qs.get('modal')) {
        navigate(orderModeURL, { replace: true });
      } else {
        navigate(orderModeURL);
      }
    } else {
      const current = location.pathname.split('/');
      if (current[2] === 'home') {
        navigate(orderModeURL, { state: { action: action } });
      } else {
        navigate(orderModeURL, { replace: true, state: { action: action } });
      }
    }
  };

  const search = new URLSearchParams(location.search);
  const modalName = (search.get('modal') || '').toLowerCase();
  if (!orderModes || orderModes.length === 0) return '';
  let selectedComponent = null;
  if (selectedOrderMode === 0 && modalName === 'delivery') {
    selectedComponent = modeRoute[selectedOrderMode].component;
  } else if (isUserAccessFirstTime && selectedOrderMode === 'delivery') {
    selectedComponent =
      modeRoute[window.localStorage.getItem('addressType')?.toLowerCase()].component;
  } else if (selectedOrderMode === 0 && modalName !== 'delivery') {
    selectedComponent = modeRoute[modalName]?.component;
  } else {
    selectedComponent = modeRoute[modalName]?.component;
  }
  // let width = window.screen.width;
  // alert(width);
  // 2560;

  // const difference = width - 1440;
  // const position = width > 1440 ? difference / 2 + 163 : 163;
  // const arbicWidth = width > 1440 ? width - difference / 2 - 530 : width - 600;
  // let arabicPosition = width > 1440 ? arbicWidth - 263 : width - 800;

  // const positionPop = {
  //   horizontal: intl.locale === 'en' ? position : arabicPosition,
  //   vertical: 1,
  // };
  const selectedTab = selectedIdx !== null ? selectedIdx : tab;

  const getURL = ({ path, queryParams, modeType, isDesktop, locale }) => {
    let modeName = modeType;
    if (isUserAccessFirstTime && modeName === 'delivery') {
      modeName = 'delivery';
    } else if (
      modeName === 'delivery' &&
      mainAddress?.data?.info &&
      mainAddress?.data?.info?.length === 0
    ) {
      modeName = 'addAddress';
    }
    let generatedUrl = getOrderModeLink({
      path,
      modeType: modeName,
      isDesktop,
      locale,
      queryParams,
    });
    return generatedUrl || '';
  };
  return (
    <React.Fragment>
      <Tabs
        value={selectedTab}
        onChange={handleOrderModeChange}
        indicatorColor="primary"
        textColor="primary"
        // variant="scrollable"
        TabIndicatorProps={!isDesktop ? { style: { display: 'none' } } : {}}
        variant={isDesktop ? 'scrollable' : 'fullWidth'}
        scrollButtons="off"
        aria-label="Select order mode"
        ref={refRoot}
        className={ClassNames(
          css.root,
          { [css.isDesktopHeader]: isDesktopHeader },
          { [css.activeMode]: modalName && isOrderModeDialogOpen }
        )}
      >
        {orderModes.map((orderMode, idx) => {
          const title = lang === 'en' ? orderMode.name : orderMode.nameAr;
          const imgSrc = `${imgBaseUrl.home}${
            idx === selectedIdx ? orderMode.imageAlt : orderMode.image
          }`;
          let check = false;
          if (selectedTab === idx) {
            check = true;
          }
          return (
            <Tab
              key={orderMode.type}
              href={getURL({
                path: location.pathname,
                queryParams: location.search,
                modeType: orderMode.type.toLowerCase(),
                isDesktop: isDesktop,
                locale: intl.locale,
              })}
              // component={Link}
              className={ClassNames(css.tab, { [css.selectedTab]: check ? true : false })}
              label={
                check ? (
                  <div className={css.selectedLabel}>
                    <FaCheck />
                    <span>{title}</span>
                  </div>
                ) : (
                  title
                )
              }
              icon={
                <OrderModeButton
                  imgSrc={imgSrc}
                  title={title}
                  isSelected={check}
                  className={ClassNames({ [css.orderModeButton]: isDesktopHeader })}
                />
              }
              disabled={!orderMode.enable}
            />
          );
        })}
      </Tabs>
      <Popover
        open={isOrderModeDialogOpen}
        onClose={handleDialogClose}
        {...(positionPop ? { anchorOrigin: positionPop } : {})}
        className={css.popRoot}
      >
        <div className={ClassNames(css.popoverMain, selectedOrderMode)}>{selectedComponent}</div>
      </Popover>
      {/* {isOrderModeDialogOpen ? (
        <DialogBox
          title=""
          size="sm"
          height="55.5rem"
          titleDesc=""
          isOpen={isOrderModeDialogOpen}
          onClose={handleDialogClose}
          page="login"
        >
          <DialogContent dividers={true}>{modeRoute[selectedOrderMode].component}</DialogContent>
        </DialogBox>
      ) : (
        ''
      )} */}
    </React.Fragment>
  );
}
